var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _circle2, _circle3, _circle4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOikosEduDefaultBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1000",
    role: "img",
    "aria-label": "OikosEDU default student background",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "navy",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#184c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032c55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orange",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb23f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6b00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ice",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdddeb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 28,
    floodColor: "#0b2f55",
    floodOpacity: 0.12
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#fffdf9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#fff7ec",
    opacity: 0.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 116h117c41 0 74 33 74 74v0c0 20-8 38-22 52L0 411Z",
    fill: "url(#orange)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 411 214 197c25-25 66-25 91 0v0c25 25 25 66 0 91L69 524c-38 38-69 24-69-30Z",
    fill: "url(#ice)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h536L374 162c-24 24-56 38-90 38H0Z",
    fill: "url(#navy)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305 0 117 200",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1595,
    cy: -16,
    r: 205,
    fill: "url(#ice)",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1600 346v654h-441c-59 0-96-64-67-116l205-367c59-106 171-171 292-171Z",
    fill: "url(#ice)",
    opacity: 0.62
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1600 606h-234c-29 0-57 12-77 33L1086 852",
    fill: "none",
    stroke: "#ff8a00",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1600 821v179h-373l123-126c30-31 71-53 115-53Z",
    fill: "url(#navy)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1600 826h-113c-44 0-87 18-118 49L1245 1000h-190l79-89c26-29 63-46 102-46h73c31 0 61-13 83-35l13-13c28-28 66-44 106-44h89Z",
    fill: "url(#orange)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1324 1000 1468 856c19-19 45-30 72-30h60",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 1000,
    r: 440,
    fill: "url(#ice)",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 914,
    r: 34,
    fill: "url(#orange)",
    opacity: 0.92
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 1001,
    r: 96,
    fill: "url(#ice)",
    opacity: 0.86
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0b3a68"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 151,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 151,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 178,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 178,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 205,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 205,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 232,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 232,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 259,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 259,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 932,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 932,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 932,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 957,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 957,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 957,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 982,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 982,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 982,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 206,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 248,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 290,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9db7d4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1218,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1242,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1266,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1314,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1218,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1242,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1266,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1314,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1194,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1218,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1242,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1266,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1314,
    cy: 69,
    r: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#f59a23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 973,
    cy: 815,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 815,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019,
    cy: 815,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 815,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 973,
    cy: 838,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 838,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019,
    cy: 838,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 838,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 973,
    cy: 861,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 861,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019,
    cy: 861,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 861,
    r: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#8eabd0",
    strokeWidth: 3,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 770,
    r: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127,
    cy: 770,
    rx: 68,
    ry: 25,
    transform: "rotate(-14 127 770)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127,
    cy: 770,
    rx: 27,
    ry: 68,
    transform: "rotate(-28 127 770)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 689 162 850M55 774h144M82 852h91M89 685l12 15M73 683c11-1 22 2 31 9M66 850c35 16 78 15 113-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 675c-13 4-19 14-13 28"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#8eabd0",
    strokeWidth: 3,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342 800 393 776l53 24-53 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 810v25c19 13 44 13 63 0v-25M446 800v46M446 846l-6 14h12Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#9cb8d8",
    strokeWidth: 3,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1288 154c24-15 49-15 65 0 20-17 45-18 67-4v67c-23-9-48-9-67 9-18-16-42-21-65-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353 154v72M1373 170h31M1373 188h29M1373 207h24M1298 172h34M1298 192h34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 207,
    r: 22,
    fill: "url(#orange)",
    stroke: "none"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0d3d70",
    strokeWidth: 3,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1392 781h158a11 11 0 0 1 0 22h-158a36 36 0 0 0 0 72h168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 730h136a10 10 0 0 1 0 20h-136a28 28 0 0 0 0 56h148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418 805v67M1439 805v67M1418 805h21v30l-10-8-11 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 764h169M1392 839h169M1415 750h139"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451,
    y: 426,
    width: 698,
    height: 179,
    rx: 22,
    fill: "#ffffff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451,
    y: 426,
    width: 698,
    height: 179,
    rx: 22,
    fill: "none",
    stroke: "#ff6b00",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 493,
    y: 557,
    fontFamily: "Inter, Arial, Helvetica, sans-serif",
    fontSize: 124,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#3e3f42"
  }, "Oikos"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#ff6b00"
  }, "EDU")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOikosEduDefaultBackground);
export default __webpack_public_path__ + "static/media/Oikos-EDU-Default-Background.bbf4cc4a062d16b05cbd2a87e3b019a5.svg";
export { ForwardRef as ReactComponent };